module.exports = __webpack_public_path__ + "img/leo_micas.038630dd.jpg";